import React, { Suspense } from "react";
import { Router, Route, Switch } from "react-router-dom";
import history from "./core/utils/history";
import { browserDetector, windowResize } from "./core/utils";
import { routes } from "./core/routes";
import { GlobalStyle, Container, Row, MainContent } from "./core/styles";

import Loading from "./components/Loading";
import ErrorPage from "./screens/ErrorPage";
import PrivateRoute from "./components/PrivateRoute";
import * as config from "./core/config/global.config.json";
import { ThemeProvider } from "styled-components";
import { themeIddaa } from "./core/styles/variables";

const App = () => {
    browserDetector();
    windowResize();
    window.addEventListener("resize", windowResize);
    setInterval("window.location.reload();", config["default"].refreshTime * 60 * 60 * 1000); // x saat

    if (typeof fetch !== "undefined" && typeof AbortController === "undefined") {
        console.warn("Fetch is supported, but not AbortController.  Dropping default fetch so SignalR can override.");
        window.fetch = undefined;
    }

    window.addEventListener('online', function() {
        window.location.reload();
    });

    return (
        <Router history={history}>
            <ThemeProvider theme={themeIddaa}>
                <GlobalStyle />
                <Container noPadding>
                    <Row fullHeight noMargin>
                        <Suspense fallback={<Loading />}>
                            <MainContent col12>
                                <Container noPadding>
                                    <Switch>
                                        {routes.map(({ path, Component, requireAuth }) => {
                                            if (requireAuth) {
                                                return <PrivateRoute exact key={path} path={path}
                                                                     component={Component} />;
                                            } else {
                                                return <Route key={path} exact path={path}
                                                              render={() => <Component />} />;
                                            }
                                        })}
                                        <Route render={() => <ErrorPage />} />
                                    </Switch>
                                </Container>
                            </MainContent>
                        </Suspense>
                    </Row>
                </Container>
            </ThemeProvider>
        </Router>
    );
};

export default App;
